export type Point = {
  x: number;
  y: number;
};

export type ImageDimensions = {
  width: number;
  height: number;
};

export const RGBA_CHANNELS = 4;

export function getPixelIndex(x: number, y: number, width: number): number {
  return (y * width + x) * RGBA_CHANNELS;
}
